import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNumber1Square: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="number-1-square, key"><path d="M20.25 3.75H3.75V20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M11.7344 16.2275V9.26074H11.6348L9.53125 10.749V9.3252L11.7402 7.77246H13.2461V16.2275H11.7344Z" fill="currentColor"/></CentralIconBase>;
};

export default IconNumber1Square;
